module.exports = __webpack_public_path__ + "img/ic-ford.ed935b1e.png";